var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupporticon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MirrorFly_Support",
    "data-name": "MirrorFly Support",
    transform: "translate(-1716 -287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32909",
    "data-name": "Group 32909",
    transform: "translate(1716 287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    fill: "#e0e0ed",
    stroke: "#474891",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(24 24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 32,
    height: 32,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(-934.468 -387.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M950.353,391.5a10.247,10.247,0,0,1,9.052,9.042",
    transform: "translate(3.53 0)",
    fill: "none",
    stroke: "#130f26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M950.353,395.043a5.691,5.691,0,0,1,4.5,4.5",
    transform: "translate(3.53 1.013)",
    fill: "none",
    stroke: "#130f26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M949.613,404.322c5.129,5.128,6.291-.8,9.557,2.46,3.149,3.148,4.959,3.778.97,7.766-.5.4-3.675,5.232-14.831-5.921s-6.329-14.334-5.927-14.833c4-4,4.62-2.179,7.767.968C950.413,398.027,944.484,399.194,949.613,404.322Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#130f26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupporticon);
export default __webpack_public_path__ + "static/media/supporticon.4f6cf6ed97c64034bc4b080026be6422.svg";
export { ForwardRef as ReactComponent };